module.exports = __webpack_public_path__ + "static/media/g0v.jump.l.1476e4fb.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/g0v.jump.l.gif
// module id = 2314
// module chunks = 1